/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pressure.reducer';

export const PressureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pressureEntity = useAppSelector(state => state.pressure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pressureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pressure.detail.title">Pressure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pressure.id">Id</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pressure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pressure.active">Active</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.pressure.created">Created</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.created ? <TextFormat value={pressureEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="maxReading">
              <Translate contentKey="tinyMedicRestApp.pressure.maxReading">Max Reading</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.maxReading}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pressure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.microSec}</dd>
          <dt>
            <span id="minReading">
              <Translate contentKey="tinyMedicRestApp.pressure.minReading">Min Reading</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.minReading}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pressure.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.timestampentry}</dd>
          <dt>
            <span id="pulse">
              <Translate contentKey="tinyMedicRestApp.pressure.pulse">Pulse</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.pulse}</dd>
          <dt>
            <span id="oximetry">
              <Translate contentKey="tinyMedicRestApp.pressure.oximetry">Oximetry</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.oximetry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pressure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pressureEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pressure.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{pressureEntity.glucoUser ? pressureEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pressure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pressure/${pressureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PressureDetail;
